var exports = {
  "M": "xa15a2ab7--439b4c--price-discount",
  "m": "xa15a2ab7--439b4c--old-price",
};

module.exports = exports;
